import classes from "./NavigationPage.module.css"

const NavigationPage = () => {
    return (
    <div className={classes.page_wrapper}>
        <div className={classes.button_container}>
            <h1>You can now choose from the navbar.</h1>
        </div>
    </div>
    )
}

export default NavigationPage